export default __webpack_public_path__ + "static/media/77777.3eead2ab.PNG";